import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import workProjects from '../data/workProjects';
import Header from './Header';
import Footer from './Footer';

const FeatureBullet = () => (
  <span style={{
    display: 'inline-block',
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#c9f31d',
    flexShrink: 0,
    marginTop: '5px',
  }} />
);

const WorkDetailPage = ({ language, setLanguage, workId: propId }) => {
  const { id: paramId } = useParams();
  const id = propId || paramId;
  const project = workProjects.find((p) => p.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!project) {
    return (
      <div className="App">
        <Header language={language} setLanguage={setLanguage} />
        <section className="service__section pt-120 pb-120">
          <div className="container" style={{ textAlign: 'center' }}>
            <h2 style={{ color: '#c9f31d' }}>Project not found</h2>
            <Link to="/#work" style={{ color: '#c9f31d', marginTop: '2rem', display: 'inline-block' }}>
              ← Back to Works
            </Link>
          </div>
        </section>
        {/* <Footer /> */}
      </div>
    );
  }

  const title = language === 'zh' ? project.titleZh : project.titleEn;
  const category = language === 'zh' ? project.categoryZh : project.categoryEn;
  const hasMultipleImages = project.images.length > 1;
  const currentIndex = workProjects.findIndex((p) => p.id === id);
  const prev = workProjects[currentIndex - 1];
  const next = workProjects[currentIndex + 1];

  return (
    <div className="App">
      <Header language={language} setLanguage={setLanguage} />

      <section className="service__section pt-120 pb-120">
        <div className="container">

          {/* Back link */}
          <div style={{ marginBottom: '2.5rem' }}>
            <Link
              to="/#work"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: '#c9f31d',
                textDecoration: 'none',
                fontWeight: 500,
                fontSize: '0.95rem',
              }}
            >
              ← {language === 'zh' ? '返回工程案例' : 'Back to Works'}
            </Link>
          </div>

          {/* Title */}
          <div className="project__head text-center mb-60">
            <span
              className="common__sub aos-init aos-animate"
              data-aos="fade-down"
              data-aos-duration="1000"
            >
              {category}
            </span>
            <h2
              className="fw-500 aos-init aos-animate"
              data-aos="fade-up"
              data-aos-duration="1200"
              style={{ color: '#c9f31d' }}
            >
              {title}
            </h2>
          </div>

          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            {/* Image Grid */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: hasMultipleImages
                  ? project.images.length === 3
                    ? 'repeat(3, 1fr)'
                    : 'repeat(2, 1fr)'
                  : '1fr',
                gap: '1rem',
                marginBottom: '2rem',
              }}
            >
              {project.images.map((img, idx) => (
                <div key={idx} style={{ borderRadius: '10px', overflow: 'hidden', lineHeight: 0 }}>
                  <img
                    src={img.src}
                    alt={img.alt}
                    style={{
                      width: '100%',
                      height: '320px',
                      objectFit: 'cover',
                      display: 'block',
                      borderRadius: '10px',
                    }}
                  />
                </div>
              ))}
            </div>

            {/* Project Info */}
            <div style={{ marginBottom: '3rem' }}>
              <h3 style={{ fontSize: '1.6rem', fontWeight: 700, color: '#ffffff', marginBottom: '2rem' }}>
                {language === 'zh' ? '項目資料' : 'Project Info'}
              </h3>
              <div style={
                {
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '2rem 3rem',
                }
              }>
                <div>
                  <p style={{ color: '#ffffff', fontWeight: 600, fontSize: '1rem', marginBottom: '0.4rem' }}>
                    {language === 'zh' ? '客戶' : 'Client'}
                  </p>
                  <p style={{ color: '#888888', fontSize: '0.95rem', margin: 0 }}>
                    {language === 'zh' ? project.info.clientZh : project.info.clientEn}
                  </p>
                </div>
                <div>
                  <p style={{ color: '#ffffff', fontWeight: 600, fontSize: '1rem', marginBottom: '0.4rem' }}>
                    {language === 'zh' ? '類別' : 'Category'}
                  </p>
                  <p style={{ color: '#888888', fontSize: '0.95rem', margin: 0 }}>
                    {language === 'zh' ? project.categoryZh : project.categoryEn}
                  </p>
                </div>
                <div>
                  <p style={{ color: '#ffffff', fontWeight: 600, fontSize: '1rem', marginBottom: '0.4rem' }}>
                    {language === 'zh' ? '地點' : 'Location'}
                  </p>
                  <p style={{ color: '#888888', fontSize: '0.95rem', margin: 0 }}>
                    {language === 'zh' ? project.info.locationZh : project.info.locationEn}
                  </p>
                </div>
              </div>
            </div>

            {/* Features */}
            {project.features.length > 0 && (
              <div
                style={{
                  background: 'rgba(255, 255, 255, 0.03)',
                  padding: '2rem 2.5rem',
                  borderRadius: '12px',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  marginBottom: '2rem',
                }}
              >
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {project.features.map((feature, idx) => (
                    <li
                      key={idx}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '0.75rem',
                        padding: '0.6rem 0',
                        borderBottom:
                          idx < project.features.length - 1
                            ? '1px solid rgba(255,255,255,0.06)'
                            : 'none',
                      }}
                    >
                      <FeatureBullet />
                      <span className="pra fz-16" style={{ color: '#e0e0e0', lineHeight: '1.6' }}>
                        {language === 'zh' ? feature.zh || feature.en : feature.en}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Prev / Next navigation */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: '2rem',
              borderTop: '1px solid rgba(255,255,255,0.1)',
              gap: '1rem',
            }}>
              {prev ? (
                <Link
                  to={`/#work/${prev.id}`}
                  style={{ color: '#c9f31d', textDecoration: 'none', fontWeight: 500, fontSize: '0.9rem' }}
                >
                  ← {language === 'zh' ? prev.titleZh : prev.titleEn}
                </Link>
              ) : <span />}
              {next ? (
                <Link
                  to={`/#work/${next.id}`}
                  style={{ color: '#c9f31d', textDecoration: 'none', fontWeight: 500, fontSize: '0.9rem', textAlign: 'right' }}
                >
                  {language === 'zh' ? next.titleZh : next.titleEn} →
                </Link>
              ) : <span />}
            </div>
          </div>
        </div>
      </section>

      {/* <Footer /> */}
    </div>
  );
};

export default WorkDetailPage;
